import { UIComponentProps, UIComponentImpl, UIComponentHandler, UIComponentState, UIDataModel } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ToneOptionCardViewImpl } from './toneoptioncardview';
import { ToneOptionCardCSSStyleImpl } from './toneoptioncardcss';

export interface ToneOptionCardComponentProps extends UIComponentProps
{
    iconName:string;
    title:string;
}

export class ToneOptionCardComponent extends UIComponentImpl<ToneOptionCardComponentProps, UIComponentState, UIDataModel>
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ToneOptionCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ToneOptionCardCSSStyleImpl(applicationContext);
    }   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptioncard/toneoptioncardcomponent.tsx